import {IResponse, requestWithToken} from "./RequestBase";
import {config} from "../config";
import {IPerson} from "../store/slicePerson";
import {store} from "../store/configureStore";
import {actions as actionsPerson} from "../store/slicePerson";
import {actions as modal} from "../store/sliceModal";

export const fetchAllPersons = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.birthdayUrl}/api/all`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        },
        false,
        true
    );

    if (data.isSuccess) {
        store.dispatch(actionsPerson.setPersons(data.data))
    }

    if (data.status === 401) {
        store.dispatch(modal.showError("Отказано в доступе"))
    }

    return data;
}

export const deletePersons = async (id: number): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.birthdayUrl}/api/${id}`,
        {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
            }
        },
        false,
        true
    );

    if (data.status === 204) {
        store.dispatch(actionsPerson.deletePerson(id))
    }
    return data;
}

export const createOrUpdatePersons = async (person: IPerson): Promise<IResponse> => {
    const request = person.id == null ? `${config.birthdayUrl}/api/create` : `${config.birthdayUrl}/api/update`

    const data: IResponse = await requestWithToken(request,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(person)
        },
        false,
        true
    );

    if (data.isSuccess) {
        person.id ? store.dispatch(actionsPerson.updatePerson(data.data)) : fetchAllPersons()
    }
    return data;
}
